import { BaseModel } from '../base.model';

export enum SystemFileDirectories {
  Documents = 'Documents',
  Images = 'Images',
}

export enum SystemMediaDirectories {
  Images = 'Images',
}

export enum FileDirectoryKeys {
  name = 'name',
  isSystem = 'isSystem',
  parentId = 'parentId',
}

export class FileDirectory extends BaseModel {
  [FileDirectoryKeys.name]: string;
  [FileDirectoryKeys.isSystem]: boolean;
  [FileDirectoryKeys.parentId]?: string | null;
}

export const AGENT_SYSTEM_DIRECTORY_NAMES: string[] = [SystemFileDirectories.Images, SystemFileDirectories.Documents];
export const SYSTEM_MEDIA_DIRECTORY_NAMES: string[] = [SystemFileDirectories.Images];
